import { currencySchema } from '../../../types/utils.mjs';
import { Get as Get$1 } from '../../carrier/carrier-preview.dto.mjs';

var Get;
(function (Get) {
    (function (Response) {
        Response.schema = Get$1.Response.schema.extend({
            singleBondAuthority: currencySchema,
            aggregateBondAuthority: currencySchema,
            tListingAmount: currencySchema.nullable(),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));

export { Get };
